import type { FieldSelection } from '#layers/data-model';
import type { ResolvedMonospacePrimitiveField } from '#layers/data-model/types/schema/resolved-schema';

/**
 * Ensures the given primitive fields are present in a field selection.
 * Used by relation composables to inject FK fields that rstore needs for cache matching
 * but which aren't part of the display template.
 */
export function injectConstraintFields(
	selection: FieldSelection,
	constraintFields: ResolvedMonospacePrimitiveField[],
): FieldSelection {
	if (constraintFields.length === 0) return selection;
	if (selection.includes('*')) return selection;

	const existing = new Set(selection.filter((item): item is string => typeof item === 'string'));
	const missing = constraintFields.filter((f) => !existing.has(f.apiName));

	if (missing.length === 0) return selection;
	return [...selection, ...missing.map((f) => f.apiName)];
}
